import { DefaultState, DropdownItem } from 'store/types';

export const GET_FORM_DATA_REQUEST = 'GET_FORM_DATA_REQUEST';
export const GET_FORM_DATA_SUCCESS = 'GET_FORM_DATA_SUCCESS';
export const GET_FORM_DATA_FAILURE = 'GET_FORM_DATA_FAILURE';

export enum GuetsTypes {
  RegularGuest = 'RegularGuest',
  CorporateTraveler = 'CorporateTraveler'
}

interface Roommate {
  id: string;
  firstName: string;
  lastName: string;
}

interface Guest {
  id: string;
  guestType: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  gender: string;
}

interface LocationView {
  longitude: number;
  latitude: number;
}

export interface GetFormData {
  lodgingTypes: DropdownItem[];
  id?: string;
  guest?: Guest;
  roommates?: Roommate[];
  locationId?: string;
  fromDate?: string;
  toDate?: string;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  location?: LocationView;
  lodgingNotes?: string;
  lodgingTypesSelected?: string[];
  storeNumber?: string;
  corporateClientName?: string;
  talentAgentEmail?: string;
  startTimeOfJob?: string;
  doNotSendToGuest?: boolean;
  doNotSendToCLC?: boolean;
  status?: string;
  lodgingCost?: string;
  datesScheduled?: string;
  isValidPhoneNumber?: boolean;
  guetsTypesSelectList?: DropdownItem[];
  reservationProviderId?: string;
  reservationProviderName?: string;
  providerSendNotification?: boolean;
};

export type GetFormDataState = DefaultState & {
  contents?: GetFormData;
};

interface GetFormDataRequest {
  type: typeof GET_FORM_DATA_REQUEST;
};

interface GetFormDataSuccess {
  type: typeof GET_FORM_DATA_SUCCESS,
  contents: GetFormData;
}

interface GetFormDataFailure {
  type: typeof GET_FORM_DATA_FAILURE;
}

export type GetFormDataActionTypes = GetFormDataRequest | GetFormDataSuccess | GetFormDataFailure;